<template>
<div>
  <v-card style="margin-top: 250px">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <h1 align="center" style="text-decoration: underline overline;">RINGKASAN PENDAPATAN AHLI ISI RUMAH (AIR)</h1>
      <v-text-field
        outlined 
        dense
        rounded
        v-model="HID"
        label="HID"
        width="20px"
        disabled
      ></v-text-field>

    <v-card class="mt-4">

  <!-- <v-card-title style="text-decoration: underline overline;">
    RINGKASAN PENDAPATAN AHLI ISI RUMAH (AIR)
  </v-card-title>   -->

  <v-card-text>
    <v-simple-table 
    fixed-header
    dense>
      <thead>
        <tr>
          <th class="text-h6 orange lighten-4" ><strong>
            PUNCA PENDAPATAN
          </strong></th>

          <th class="text-h6 orange lighten-4">
            KOD INCS
          </th>

          <th class="text-h6 orange lighten-4" v-for="item in summaryData.dataJR5" 
            :key="item.NOAIR">
            {{item.NOAIR}}
          </th>

          <th style="text-align:center;" class="text-h6 orange lighten-4">
            JUMLAH PENDAPATAN <br>ISI RUMAH
          </th> 
        </tr>
      </thead>

      <tbody>
        <!-- <tr>
              <th colspan="10" style="text-align:center;"><strong>Pendapatan Bergaji</strong></th>
        </tr> -->

        <!-- INCS01 -->
        <tr>
          <td><strong>Jumlah Pendapatan Pekerjaan Bergaji</strong></td>
          <td>INCS01</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS01}}
          </td>

          <td style="text-align:center;" > {{totalINCS01}}</td>

        </tr>

        <!-- HK221A -->
        <tr>
          <td>Jumlah Pendapatan Bekerja Sendiri (Pertanian)</td>

          <td>INCS21A</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.HK2INCS21a}}
          </td>

          <td style="text-align:center;" > {{totalHK2INCS21a}}</td>

        </tr>

        <!-- HK321A -->
        <tr>
          <td>Jumlah Pendapatan Bekerja Sendiri (Perikanan)</td>

          <td>INCS21A</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.HK3INCS21a}}
          </td>

          <td style="text-align:center;"> {{totalHK3INCS21a}}</td>

        </tr>

        <!-- INCS21b -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN ICT</strong></td>

          <td><strong>INCS21b</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.HK4INCS21b}}
          </td>

          <td style="text-align:center;" >{{totalHK4INCS21b}}</td>
        </tr>

        <!-- INCS21c -->
        <tr>
          <td><strong>KOMISEN DARIPADA AKTIVITI ICT</strong></td>

          <td><strong>INCS21c</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.HK4INCS21c}}
          </td>

          <td style="text-align:center;" >{{totalHK4INCS21c}}</td>
        </tr>

        <!-- INCS21d -->
        <tr>
          <td>Jumlah Pendapatan Bekerja Sendiri (Pengangkutan)</td>

          <td>INCS21d</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.HK5INCS21d}}
          </td>

          <td style="text-align:center;"> {{totalHK5INCS21d}}</td>

        </tr>

        <!-- INCS21e -->
        <tr>
         <td>Jumlah Pendapatan Bekerja Sendiri (Lain-lain)</td>

          <td>INCS21e</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.HK6INCS21e}}
          </td>

          <td style="text-align:center;"> {{totalHK6INCS21e}}</td>

        </tr>

        <!-- INCS21NA -->
        <tr>
          <td>Jumlah Pendapatan Bekerja Sendiri (Bukan Pertanian)</td>

          <td>INCS21NA</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS21NA}}
          </td>

          <td style="text-align:center;"> {{totalINCS21NA}}</td>

        </tr>

        <!-- INCS21KS -->
        <tr>
          <td><strong>Kegunaan Sendiri</strong></td>

          <td>INCS21KS</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS21KS}}
          </td>

          <td style="text-align:center;"> {{totalINCS21KS}}</td>

        </tr>

        <!-- INCS21 -->
        <tr>
          <td>Jumlah Pendapatan Pekerjaan Sendiri</td>

          <td>INCS21</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS21}}
          </td>

          <td style="text-align:center;"> {{totalINCS21}}</td>

        </tr>

        <!-- INCS22 -->
        <tr>
          <td>Jumlah Sewa Dinilai</td>

          <td>INCS22</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS22}}
          </td>

          <td style="text-align:center;"> {{totalINCS22}}</td>

        </tr>

        <!-- INCS23 -->
        <tr>
          <td>Jumlah harta lain yang disewakan</td>

          <td>INCS23</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS23}}
          </td>

          <td style="text-align:center;"> {{totalINCS23}}</td>

        </tr>

        <!-- INCS24 -->
        <tr>
          <td>Jumlah sewa dari tempat menginap</td>

          <td>INCS24</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS24}}
          </td>

          <td style="text-align:center;"> {{totalINCS24}}</td>

        </tr>

        <!-- INCS02 -->
        <tr>
          <td>Jumlah Pendapatan Lain Diperoleh</td>

          <td>INCS02</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS02}}
          </td>

          <td style="text-align:center;"> {{totalINCS02}}</td>

        </tr>

        <!-- INCS31 -->
        <tr>
          <td>Royalti</td>

          <td>INCS31</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS31}}
          </td>

          <td style="text-align:center;"> {{totalINCS31}}</td>

        </tr>

        <!-- INCS32a -->
        <tr>
          <td>Sewa daripada tanah pertanian</td>

          <td>INCS32a</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS32a}}
          </td>

          <td style="text-align:center;"> {{totalINCS32a}}</td>

        </tr>

        <!-- INCS32b -->
        <tr>
          <td>Sewa daripada tanah bukan pertanian</td>

          <td>INCS32b</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS32b}}
          </td>

          <td style="text-align:center;"> {{totalINCS32b}}</td>

        </tr>

        <!-- INCS33 -->
        <tr>
          <td>Faedah</td>

          <td>INCS33</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS33}}
          </td>

          <td style="text-align:center;"> {{totalINCS33}}</td>

        </tr>

        <!-- INCS34 -->
        <tr>
          <td>Dividen</td>

          <td>INCS34</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS34}}
          </td>

          <td style="text-align:center;"> {{totalINCS34}}</td>

        </tr>

        <!-- INCS03 -->
        <tr>
          <td>Jumlah Pendapatan Daripada Harta</td>

          <td>INCS03</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS03}}
          </td>

          <td style="text-align:center;"> {{totalINCS03}}</td>

        </tr>

        <!-- INCS05 -->
        <tr>
          <td>Jumlah Pindahan Semasa Yang Diterima</td>

          <td>INCS05</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS05}}
          </td>

          <td style="text-align:center;"> {{totalINCS05}}</td>

        </tr>

         <!-- TP73 -->
        <tr>
          <td>Jumlah Bayaran Pindahan Semasa</td>

          <td>TP73</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.TP73}}
          </td>

          <td style="text-align:center;"> {{totalTP73}}</td>

        </tr>

        <!-- INCS06 -->
        <tr>
          <td>Jumlah Pindahan Semasa Bersih yang Diterima</td>

          <td>INCS06</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS06}}
          </td>

          <td style="text-align:center;"> {{totalINCS06}}</td>

        </tr>

        <!-- INCS07 -->
        <tr>
           <td>Jumlah Kasar</td>

          <td>INCS07</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS07}}
          </td>

          <td style="text-align:center;"> {{totalINCS07}}</td>

        </tr>

        <!-- INCS08 -->
        <tr>
          <td>Jumlah Bersih</td>

          <td>INCS08</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR">
            {{item.INCS08}}
          </td>

          <td style="text-align:center;"> {{totalINCS08}}</td>

        </tr>
      </tbody>
    </v-simple-table>
  </v-card-text>
</v-card>
</v-card>
</div>
</template>

<script>
// @ is an alias to /src

//////////////services//////////////////
import pubServices from '@/services/publicServices'
const publicServices = new pubServices();

import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

import maklumatIsiRumah from '@/services/ringkasanMaklumatIsiRumah'
const servicesMaklumatIsiRumah = new maklumatIsiRumah();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();


export default {

  // components: {
  //   PieChart
  // },
  async beforeMount(){
    //this.userData = localStorageData.user();
    var dataHID = localStorageData.getHIDdata()
 
    this.HID = dataHID.HID;
    this.BNO = dataHID.BNO;
    this.Ps = dataHID.P;
    this.S = dataHID.S;
    this.NG = dataHID.NG;
    this.DP = dataHID.DP;
    this.DB =  dataHID.DB;
    this.BP = dataHID.BP;
    this.ST = dataHID.ST;
    this.NOTK = dataHID.NOTK;
    this.NOIR = dataHID.NOIR;
    this.KAW = dataHID.KAW;
    this.BULAN = dataHID.BULAN;
    this.TAHUN = dataHID.TAHUN;
   
    this.summaryData = await servicesMaklumatIsiRumah.getMaklumatIsiRumahByHID(this.HID);
    console.log(this.summaryData)

  },
  data: () => ({

    summaryData:[],

    ///////////link untuk ke page/////////////////////
    breadcrumbs: [
      {
        text: 'Status Pengisian',
        disabled: false,
        href: 'ringkasanMaklumatIR',
      },
      {
        text: 'Ringkasan Pendapatan Ahli Isi Rumah (AIR)',
        disabled: true,
        href: 'ringkasanpendapatanAIR',
      },
    ],

  }),
  methods:{
  },
  computed:{
   
     totalINCS01: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS01)
        //total = Number(total) + Number(this.summaryData.dataJR5[i].INCS11) + Number(this.summaryData.dataJR5[i].INCS12) + Number(this.summaryData.dataJR5[i].INCS13) + Number(this.summaryData.dataJR5[i].INCS14) + Number(this.summaryData.dataJR5[i].INCS15) + Number(this.summaryData.dataJR5[i].INCS16) + Number(this.summaryData.dataJR5[i].INCS17) + Number(this.summaryData.dataJR5[i].INCS18) + Number(this.summaryData.dataJR5[i].INCS19)       
      }
      return total;
    },
    totalHK2INCS21a: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK2INCS21a)
      }
      return total;
    },

    totalHK3INCS21a: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK3INCS21a)
        console.log(Number(this.summaryData.dataJR5[i].HK3INCS21a))
      }
      return total;
    },

    totalHK4INCS21b: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK4INCS21b)
      }
      return total;
    },

    totalHK4INCS21c: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK4INCS21c)
      }
      return total;
    },

    totalHK5INCS21d: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK5INCS21d)
      }
      return total;
    },

    totalHK6INCS21e: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK6INCS21e)
      }
      return total;
    },

    totalINCS21NA: function(){
      var total = 0;
      //for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalHK4INCS21b) + Number(this.totalHK4INCS21c) + Number(this.totalHK5INCS21d) + Number(this.totalHK6INCS21e) 
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS21e_i) + Number(this.summaryData.dataJR5[i].INCS21e_ii)+ Number(this.summaryData.dataJR5[i].INCS21e_iii)
      //}
      return total;
    },

    totalINCS21KS: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS21KS)
      }
      return total;
    },

    totalINCS21: function(){
      var total = 0;
     //for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalHK2INCS21a) + Number(this.totalHK3INCS21a) + Number(this.totalINCS21NA) + Number(this.totalINCS21KS) 
        //total = Number(total) + Number(this.summaryData.dataJR5[i].INCS21)
     // }
      return total;
    },

    totalINCS22: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS22)
      }
      return total;
    },

    totalINCS23: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS23)
      }
      return total;
    },

    totalINCS24: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS24)
      }
      return total;
    },

    totalINCS02: function(){
      var total = 0;
      // for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalINCS21) + Number(this.totalINCS22) + Number(this.totalINCS23) + Number(this.totalINCS24)  
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS02)
        //total = Number(total) + Number(this.summaryData.dataJR5[i].INCS22) + Number(this.summaryData.dataJR5[i].INCS23) + Number(this.summaryData.dataJR5[i].INCS24)
      // }
      return total;
    },

     totalINCS31: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS31)
      }
      return total;
    },

    totalINCS32a: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS32a)
      }
      return total;
    },

    totalINCS32b: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS32b)
      }
      return total;
    },

    totalINCS33: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS33)
      }
      return total;
    },

    totalINCS34: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS34)
      }
      return total;
    },

     totalINCS03: function(){
      var total = 0;
      //for(var i=0;i<this.summaryData.dataJR5.length;i++){
         total = Number(total) + Number(this.totalINCS31) + Number(this.totalINCS32a) + Number(this.totalINCS32b) + Number(this.totalINCS33) + Number(this.totalINCS34)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS03)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS31) + Number(this.summaryData.dataJR5[i].INCS32a) + Number(this.summaryData.dataJR5[i].INCS32b) + Number(this.summaryData.dataJR5[i].INCS32) + Number(this.summaryData.dataJR5[i].INCS33) + Number(this.summaryData.dataJR5[i].INCS34)
        
      //}
      return total;
    },

     totalINCS05: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS05)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS41) + Number(this.summaryData.dataJR5[i].INCS42) + Number(this.summaryData.dataJR5[i].INCS43) + Number(this.summaryData.dataJR5[i].INCS44) + Number(this.summaryData.dataJR5[i].INCS45) + Number(this.summaryData.dataJR5[i].INCS46)
      }
      return total;
    },

    totalTP73: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].TP73)
      }
      return total;
    },

    totalINCS06: function(){
      var total = 0;
      // for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalINCS05) - Number(this.totalTP73) 
        // total = Number(total) + Number(this.totalINCS05) + Number(this.totalHK4INCS21c) + Number(this.totalHK5INCS21d) + Number(this.totalHK6INCS21e) 
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS06)
      //}
      return total;
    },

     totalINCS07: function(){
      var total = 0;
      // for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalINCS01) + Number(this.totalINCS02) + Number(this.totalINCS03) + Number(this.totalINCS05)
      // }
      return total;
    },

    totalINCS08: function(){
      var total = 0;
      // for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalINCS01) + Number(this.totalINCS02) + Number(this.totalINCS03) + Number(this.totalINCS06)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS08)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS01) + Number(this.summaryData.dataJR5[i].INCS02) + Number(this.summaryData.dataJR5[i].INCS03) + Number(this.summaryData.dataJR5[i].INCS06) 
      // }
      return total;
    },

  }
}
</script>

<style>
#app{
  /* background: url('https://chatbot.dosm.gov.my/admin/files/dosm/images/chatbot/chatbotlogo.jpg') */
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}
</style>

